import type { ContextConfig, JourneyLookupConfig } from "./config-types";
import { JourneyNodeType } from "./journey-node-types";

export enum JourneyContextSource {
  Static = "static",
  HttpLookup = "http_lookup",
}

export function isHttpLookupContextConfig(
  config: unknown,
): config is ContextConfig & {
  source: JourneyContextSource.HttpLookup;
  lookup: JourneyLookupConfig;
} {
  return (
    typeof config === "object" &&
    config !== null &&
    (config as { type?: unknown }).type === JourneyNodeType.Context &&
    (config as { source?: unknown }).source === JourneyContextSource.HttpLookup
  );
}
